import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import HelpCenter from '../helpcenter/HelpCenter'; // The main HelpCenter component we created
import './HelpCenterEmbedded.css';

const HelpCenterEmbedded = () => {
  const { address, ensName, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  
  // If not authenticated, redirect to home (optional - you can remove if HelpCenter should be public)
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/home');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="help-center-embedded-wrapper">
      {/* Embedded Header - Matches ZwalletEmbedded pattern */}
      <div className="help-center-embedded-header">
        <h2 className="gold-text">📚 Zpost Help Center</h2>
        <p className="text-secondary">
          Complete documentation for the Zpost Ecosystem • Accessible to all .zpost.eth users
        </p>
      </div>
      
      {/* Full HelpCenter Component - Embedded Mode */}
      <div className="help-center-full-embedded">
        <HelpCenter 
          embedded={true}
          skipAuth={true} // HelpCenter doesn't need wallet connection
        />
      </div>
      
      {/* Footer Note - Matches your style */}
      <div className="help-center-footer-note">
        <p className="text-secondary">
          <i className="fas fa-book"></i> Documentation updated regularly • 
          Your .zpost.eth identity required for ecosystem access
        </p>
      </div>
    </div>
  );
};

export default HelpCenterEmbedded;
